import styled from "styled-components";

const StyledFooter = styled.div`
  /* max-width: 1200px; */
  margin: 0 auto;
  footer {
    background-color: #f1f1f1;
    padding: 80px 0;
    text-align: center;
  }
  .footer__freelancer {
    max-width: 400px;
  }
`;

export default StyledFooter;
